import LowFareCalendarOIContainer from '../../../../components/containers/LowFareCalendarOIContainer';
import preloadCustomProps from '../../../utils/preloads/preloadLowFareCalendarOIProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'low-fare-calendar-outbound-inbound',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: LowFareCalendarOIContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
